import React from 'react';
import Layout from '@common/layout';
import {GetStaticProps} from 'next';
import {wrapper} from '@redux/index';
import {getAppSettings, getPersonalInformation, setApp} from '@redux/app/actions';
import {EPage, TLang} from '@common/types';
import {END} from 'redux-saga';
import {PersonalInformation} from '@modules/Documents';
import {getContacts} from '@redux/contacts/actions';


const PersonalInformationPage = () => {
  return (
    <Layout
      title="Политика конфиденциальности"
      description="Размещаем политику конфиденциальности, потому что так положено по законодательству"
      classNames={['wrapper-inner']}
      pipelineId={undefined}
    >
      <PersonalInformation/>
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(store => async ({...etc}) => {
  const locale = etc.locale as TLang
  if (locale === 'en') {
    return {
      notFound: true
    }
  }
  store.dispatch(getContacts({locale}))
  store.dispatch(setApp({page: EPage.PERSONAL_INFORMATION, draftMode: etc.draftMode ?? false, noEng: true}))
  store.dispatch(getAppSettings({locale}))
  store.dispatch(getPersonalInformation())
  store.dispatch(END)
  await store?.sagaTask.toPromise()

  return {
    props: {}
  }
})

export default PersonalInformationPage
